module.exports = "button:hover {\n    background-color: #2196f3;\n}\nbutton {\n    color: white;\n}\n.confirm-message {\n    color: white;\n    font-size: x-large;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modals/confirm-modal/confirm.component.css
// module id = ./src/app/modals/confirm-modal/confirm.component.css
// module chunks = main